// Library Methods
import { useMemo } from "react";

// Components
import Grid from "@mui/material/Grid";
import Pagination from "@mui/material/Pagination";
import { useTheme } from "@mui/material/styles";

type CustomPaginationType = {
  size?: "small" | "medium";
  page: number;
  count: number;
  onChange: (event: React.ChangeEvent<unknown>, value: number) => void;
  selectedColorDark?: string;
};

const CustomPagination = ({
  size = "medium",
  page,
  count,
  onChange,
  selectedColorDark = "#4D506390",
}: CustomPaginationType) => {
  const theme = useTheme();
  const countToUse = useMemo(() => count || 0, [count]);
  const selectedColor =
    theme.palette.mode === "dark" ? selectedColorDark : "#5B6D7A20";

  return (
    <Grid
      container
      direction="row"
      alignContent="center"
      justifyContent="center"
      display={countToUse > 0 ? "flex" : "none"}
    >
      <Pagination
        data-testid="pagination"
        page={page}
        count={countToUse}
        size={size}
        onChange={onChange}
        sx={{
          ".MuiPaginationItem-root": {
            backgroundColor: "transparent",
            borderRadius: "4px",
          },
          ".MuiPaginationItem-root.Mui-selected": {
            backgroundColor: selectedColor,
            borderRadius: "4px",
          },
          ".MuiPaginationItem-root.Mui-selected:hover": {
            backgroundColor: selectedColor,
          },
        }}
      />
    </Grid>
  );
};

export default CustomPagination;
